module.exports = __webpack_public_path__ + "static/assets/default-person.986bd35.svg";